import React, { FC } from 'react';

interface TestimonialCardModel {
  imgUrl: string;
  name: string;
  testimony: string;
}

const TestimonialCard: FC<TestimonialCardModel> = ({
  imgUrl,
  name,
  testimony,
}) => {
  return (
    <div className="min-w-[300px] rounded-md bg-zinc-100 p-5 shadow-md md:min-w-[355px]">
      <p className="text-xl">"{testimony}"</p>
      <div className="my-5 flex gap-x-3">
        <img src={imgUrl} alt="user_one" className="h-16 rounded-full" />
        <p className="my-auto font-bold">{name}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;
